import theme from "@/theme";
import { MetricItem } from "../Common/types";

const status: Record<string, string> = {
  healthy: "healthy",
  needAttention: "needAttention",
  needsSupport: "needsSupport",
};

const metrics: MetricItem[] = [
  {
    id: "bp",
    title: "Blood pressure",
    value: "127/76",
    status: status.healthy,
    showChevron: true,
  },
  {
    id: "hr",
    title: "Heart rate (beats/min)",
    value: "68",
    status: status.needAttention,
    showChevron: true,
  },
  {
    id: "breathing",
    title: "Breathing (breaths/min)",
    value: "127",
    status: status.needsSupport,
    showChevron: true,
  },
];

const statusColors: Record<string, string> = {
  healthy: theme.palette.accent1.main,
  needAttention: theme.palette.secondary[700] as string,
  needsSupport: theme.palette.error.main,
};

export { metrics, statusColors, status };
